import React, { useContext, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import {
  AppBar,
  Box,
  Button,
  Drawer,
  Hidden,
  List,
  ListItem,
  Theme,
  Toolbar,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { Menu } from '@material-ui/icons';

import UserAvatar from '../components/UserAvatar';
import GradientButton from '../components/GradientButton';

import UserContext from '../contexts/UserContext';
import menus from '../config/menus';
import { auth } from '../services/firebase';
import Logo from './Logo';

interface SideBarProps {
  open: boolean;
  onClose: () => void;
}

const drawerWidth = 240;
const useStyles = makeStyles((theme: Theme) => ({
  drawerPaper: {
    width: drawerWidth,
  },
  menuButtonDisabled: {
    textDecoration: 'underline',
    color: `${theme.palette.text.primary} !important`,
    opacity: '1 !important',
  },
  menuIcon: {
    alignSelf: 'center',
    cursor: 'pointer',
    justifySelf: 'end',
    marginRight: '8px',
  },
  menuList: {
    alignItems: 'center',
    color: theme.palette.text.primary,
    display: 'flex',
    '& > *': {
      marginRight: 4,
    },
  },
  registerButton: {
    backgroundColor: '#000',
    borderRadius: 16,
    color: '#FFF',
  },
}));

const Header = () => {
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const { state } = useContext(UserContext);

  const {
    menuButtonDisabled,
    menuIcon,
    menuList,
    registerButton,
  } = useStyles();

  const renderAuth = () => {
    if (state.loading) {
      return <></>;
    }
    return state.user ? (
      <>
        <Box width={8} />
        <GradientButton
          color1="#FFD630"
          color2="#FF851A"
          text="เข้าสู่เกม"
          onClick={() => history.push('/game')}
        />
        <Box width={8} />
        <UserAvatar
          imageUrl={state.user?.photoUrl}
          onEditProfile={() => history.push('/profile')}
          onSignOut={() => auth.signOut()}
        />
      </>
    ) : (
      <>
        <Button onClick={() => history.push('/login')}>เข้าสู่ระบบ</Button>
        <Box width={8} />
        <Button
          classes={{ root: registerButton }}
          variant="contained"
          onClick={() => history.push('/register')}
        >
          ลงทะเบียน
        </Button>
      </>
    );
  };

  return (
    <>
      <AppBar position="static" color="inherit">
        <Toolbar>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            p={1}
            height={60}
            width="100%"
          >
            <div className={menuList}>
              <Hidden mdUp>
                <Menu
                  className={menuIcon}
                  color="primary"
                  onClick={() => setOpen(!open)}
                />
              </Hidden>
              <Link to="/" style={{ textDecoration: 'none' }}>
                <Logo />
              </Link>
              <Box width={8} />
              <Hidden smDown>
                {menus.map((menu, index) => (
                  <Button
                    classes={{ disabled: menuButtonDisabled }}
                    key={index}
                    onClick={() => history.push(menu.link)}
                    disabled={menu.link === history.location.pathname}
                  >
                    {menu.text}
                  </Button>
                ))}
              </Hidden>
            </div>
            <div className={menuList}>{renderAuth()}</div>
          </Box>
        </Toolbar>
      </AppBar>
      <Hidden mdUp>
        <SideBar open={open} onClose={() => setOpen(false)} />
      </Hidden>
    </>
  );
};

const SideBar: React.FC<SideBarProps> = ({ open, onClose }) => {
  const history = useHistory();
  const { drawerPaper, menuButtonDisabled } = useStyles();
  return (
    <Drawer
      classes={{ paper: drawerPaper }}
      variant="temporary"
      open={open}
      onClose={onClose}
    >
      <AppBar position="static">
        <Toolbar>
          <Box height={60} display="flex" alignItems="center">
            <Typography variant="h6" color="inherit">
              เมนูหลัก
            </Typography>
          </Box>
        </Toolbar>
      </AppBar>
      <List>
        {menus.map((menu, index) => (
          <ListItem
            key={index}
            classes={{ disabled: menuButtonDisabled }}
            button
            onClick={() => history.push(menu.link)}
            disabled={menu.link === history.location.pathname}
          >
            {menu.text}
          </ListItem>
        ))}
      </List>
    </Drawer>
  );
};

export default Header;
